import { IPlatformLogger, PlatformConfig, ServicesLoaders } from '@wix/thunderbolt-symbols'
import { NamedSignalsServiceDefinition, TestServiceDefinition } from '@wix/thunderbolt-services'
import namedSignalsServiceConfig from './configs/namedSignalsServiceConfig'
import { StyleUtilsDefinition } from '@wix/style-utils'
import { FedopsLoggerDefinition } from '@wix/viewer-service-fedops-logger/definition'
import { ServiceConfigFactory } from '../types'
import { LinkUtilsServiceDefinition } from '@wix/link-utils'
import { WixClientDefinition } from '@wix/viewer-service-wix-client/definition'
import { UrlDefinition } from '@wix/viewer-service-url/definition'

export const serviceLoaders: ServicesLoaders = {
	[TestServiceDefinition as string]: () => import('feature-test-service/service' /* webpackChunkName: "platformTestService" */),
	[NamedSignalsServiceDefinition as string]: () => import('feature-named-signals-service/service' /* webpackChunkName: "platformNamedSignalsService" */),
	[StyleUtilsDefinition as string]: () => import('feature-style-utils-service/service' /* webpackChunkName: "platformStyleUtilsService" */),
	[FedopsLoggerDefinition as string]: () => import('feature-fedops-logger-service/service' /* webpackChunkName: "platformFedopsLoggerService" */),
}

export const serviceConfigs: {
	[serviceDefinition: string]: ServiceConfigFactory
} = {
	[NamedSignalsServiceDefinition as string]: () => namedSignalsServiceConfig,
}

// TODO - remove when implemented and stable in TB
export const noopServiceDefinitions = [LinkUtilsServiceDefinition as string, WixClientDefinition as string, UrlDefinition as string]

export const getServiceDefinitionToFactoryPromise = async (serviceDefinitionToConfig: PlatformConfig | undefined, logger: IPlatformLogger) =>
	Promise.all(
		Array.from(new Set([...Object.keys(serviceDefinitionToConfig!), ...noopServiceDefinitions])).map((serviceDefinition) => {
			// TODO - remove when implemented and stable in TB
			if (noopServiceDefinitions.includes(serviceDefinition)) {
				return Promise.resolve([serviceDefinition, { impl: () => ({}) }])
			}
			const factoryGetter = serviceLoaders[serviceDefinition]
			if (!factoryGetter) {
				logger.captureError(new Error(`Service ${serviceDefinition} is not supported`), {
					tags: {
						feature: 'platform',
					},
				})
				return Promise.resolve([serviceDefinition, { impl: () => ({}) }])
			}
			return factoryGetter().then((implementation) => [serviceDefinition, implementation])
		})
	).then((servicesArray) => Object.fromEntries(servicesArray))
